import hyRequest from '@/service'
import { IDataType } from '@/service/types'

// 查询字典数据列表
export function listData(queryInfo: any) {
  return hyRequest.post<IDataType>({
    url: '/system/dict/data/list',
    data: queryInfo
  })
}

// 查询字典数据详细
export function getData(dictCode: number | string) {
  return hyRequest.get<IDataType>({
    url: '/system/dict/data/' + dictCode
  })
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType: string) {
  return hyRequest.get<IDataType>({
    url: '/system/dict/data/type/' + dictType
  })
}

// 新增字典数据
export function addData(newData: any) {
  return hyRequest.post<IDataType>({
    url: '/system/dict/data',
    data: newData
  })
}

// 修改字典数据
export function updateData(editData: any) {
  return hyRequest.patch<IDataType>({
    url: '/system/dict/data',
    data: editData
  })
}

// 删除字典数据
export function delData(dictCode: number | string) {
  return hyRequest.delete<IDataType>({
    url: '/system/dict/data/' + dictCode
  })
}